<template>
    <section
        class="signin section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="signin-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header tag="h1" :data="sectionHeader" class="center-content" />
                <div class="tiles-wrap">
                    <div class="tiles-item">
                        <div class="tiles-item-inner">
                            <form @submit.prevent="signup">
                                <fieldset>
                                    <!--<div class="mb-12">
                                        <c-input
                                            label="Full name"
                                            placeholder="Full name"
                                            label-hidden
                                            required />
                                    </div>-->
                                    <div class="mb-12">
                                        <c-input
                                            type="email"
                                            label="Email"
                                            placeholder="Email"
                                            v-model="email"
                                            label-hidden
                                            required />
                                    </div>
                                    <div :class="'mb-12 card ' + (cardfocused ? 'card-focus' : '')">
                                        <StripeElements
                                          :stripe-key="stripeKey"
                                          :instance-options="instanceOptions"
                                          :elements-options="elementsOptions"
                                          #default="{ elements }" 
                                          ref="elms"
                                        >
                                          <StripeElement
                                            @focus="cardfocused = true"
                                            @blur="cardfocused = false"
                                            type="card"
                                            :elements="elements"
                                            :options="cardOptions"
                                            ref="card"
                                            required
                                          />
                                        </StripeElements>
                                    </div>
                                    <div class="mt-24 mb-32">
                                        <c-button color="primary" :loading="inprogress" wide>{{inprogress ? '' : 'Sign up'}}</c-button>
                                        <div class="pt-24 text-xs center-content text-color-low"> 
                                          <span class="text-xxs">By creating an account on LeadGem you agree to our <a href="/policies#terms">Terms of Use</a> and <a href="/policies#">Privacy policy</a>.</span>
                                        </div>
                                    </div>
                                    
                                </fieldset>
                            </form>
                            <div class="signin-bottom has-top-divider">
                                <div class="pt-32 text-xs center-content text-color-low"> 
                                    You will not be charged until you use your $25 in free credits.
                                    <br/>
                                    <br/>
                                    Already have an account? 
                                    <router-link to="/login/" class="func-link">Log in</router-link>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
.card {
  border: 1px solid #D9E0F0; 
  border-radius: 4px; 
  padding: 14px; 
}
.card-focus { 
  border: 1px solid #8E79FC; 
}
</style>
<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CInput from '@/components/elements/Input.vue'
import CButton from '@/components/elements/Button.vue'
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus'

import { Magic } from 'magic-sdk'
import axios from 'axios';

const m = new Magic(process.env.VUE_APP_MAGIC_KEY);

var cardInputStyle = {
  base: {
    color: '#58678C',
    fontSize: '16px',
    fontFamily: '"Open Sans", sans-serif',
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: '#95A1BC',
    },
  },
  invalid: {
    color: '#e5424d',
    ':focus': {
      color: '#58678C',
    },
  },
};

export default {
  name: 'CSignupForm',
  components: {
    StripeElements,
    StripeElement,
    CSectionHeader,
    CInput,
    CButton
  },
  mixins: [SectionProps],
  mounted() {
    m.preload();
  },
  data() {
    return {
      inprogress: false,
      cardfocused: false,
      email: '',
      sectionHeader: {
        title: 'Almost there!',
        paragraph: ''
      },
      stripeKey: process.env.VUE_APP_STRIPE_KEY,
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
        // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
        fonts: [{
          cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans'
        }]
      },
      cardOptions: {
        value: {
          postalCode: ''
        },
        style: cardInputStyle
      }
    }
  },
  methods: {
   signup() {
     this.inprogress = true;
     axios.post(
        process.env.VUE_APP_API_URL + 'users/exists',
        {
          email_id: this.email
        }
      )
      .then((res) => {
        /* eslint-disable no-console */
        if (res.data != null) {
          this.sectionHeader.paragraph = 'This email already has an account.';
          this.inprogress = false
        } else {
          const groupComponent = this.$refs.elms
          const cardComponent = this.$refs.card
          const cardElement = cardComponent.stripeElement

          // Access instance methods, e.g. createToken()
          groupComponent.instance.createToken(cardElement).then(result => {
            // Handle result.error or result.token
            if (result.error) {
              this.sectionHeader.paragraph = result.error.message;
              this.inprogress = false;
              /* eslint-disable no-console */
              console.log(result.error);
            } else {
              this.$store
              .dispatch('signup', {
                email: this.email,
                token: result.token,
                showUI: true
              })
              .then(() => {
                this.inprogress = false;
                //this.$router.push({ name: 'dashboard' })
                window.location.href = '/dashboard/';
              })
              .catch((err) => {
                /* eslint-disable no-console */
                this.sectionHeader.paragraph = "We ran into an error while trying to sign you up! Please try again.";
                this.inprogress = false;
                console.log(err)
              })
            }
          })
        }
      })
      .catch((err) => {
        /* eslint-disable no-console */
        this.sectionHeader.paragraph = "We ran into an error while trying to sign you up! Please try again.";
        this.inprogress = false;
        console.log(err)
      })
   },
 },
}
</script>